import React from 'react';
import { join, map } from 'lodash';
import { Insurance } from '@lib/resources/types';
import { WithStyles, withStyles } from '@material-ui/core';

import { Typography } from 'components/v2';
import useMakeGetInsuranceAnswerTextsToShow from '../../hooks/useMakeGetInsuranceAnswerTextsToShow';

import CopyButton from '../CopyButton';

import styles from './InsuranceCaptureDetailsSection.styles';

interface InsuranceCaptureDetailsSectionProps extends WithStyles<typeof styles> {
  item: Insurance;
  shouldShowEligibility?: boolean;
}

function InsuranceCaptureDetailsSection({ item, shouldShowEligibility, classes }: InsuranceCaptureDetailsSectionProps) {
  const getInsuranceVerificationAnswers = useMakeGetInsuranceAnswerTextsToShow();
  const copyTextref = React.useRef(null);

  const answerTexts = getInsuranceVerificationAnswers(item, shouldShowEligibility);
  const textToCopy = join(
    map(answerTexts, (answer) => join(answer, ': ')),
    '\n',
  );

  const handleSelection = () => {
    if (copyTextref) {
      getSelection()?.selectAllChildren(copyTextref.current!);
    }
  };

  return (
    <div className={classes.root}>
      <div ref={copyTextref} className={classes.infoWrapper}>
        {answerTexts?.map((answer) => {
          if (answer.length > 1) {
            return (
              <div key={answer[1]}>
                <Typography variant="bW600F16">{answer[0]}:</Typography>{' '}
                <Typography variant="bW500F16">{answer[1]}</Typography>
              </div>
            );
          }
          return (
            <div key={answer[0]}>
              <Typography variant="bW600F16">{answer[0]}</Typography>
            </div>
          );
        })}
      </div>
      <CopyButton textToCopy={textToCopy} onSelection={handleSelection} />
    </div>
  );
}

export default withStyles(styles)(InsuranceCaptureDetailsSection);
